import { render, staticRenderFns } from "./dataSource.vue?vue&type=template&id=1c745fb0&scoped=true"
import script from "./dataSource.vue?vue&type=script&lang=js"
export * from "./dataSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c745fb0",
  null
  
)

export default component.exports